import { BaseLkApiAuth } from '@/api/BaseApiAuth'
import { Schedule as Data, ScheduleCollection as Collection } from '@/typings/api/LKSchedule'
import { Publication, PublicationCollection } from '@/typings/api/Publication'

interface ScheduleUpdatePayload {
  publication_id: Publication['id'];
  scheduler: Data[];
}

export class LkScheduleApi extends BaseLkApiAuth<Data, Collection> {
  protected readonly endpoint = 'scheduler';

  public getForDates(publication_id: Publication['id'], data_collection_id: PublicationCollection['id']) {
    const path = ''
    const [url] = this.getUrl(path)

    return this.request('GET', url, { params: { publication_id, data_collection_id } })
  }

  public validate(data: ScheduleUpdatePayload) {
    const path = '/update'
    const [url] = this.getUrl(path)

    return this.request<never>('POST', url, { data })
  }
}
